import { render, staticRenderFns } from "./editBooksType.vue?vue&type=template&id=5c9f344e&scoped=true&"
import script from "./editBooksType.vue?vue&type=script&lang=js&"
export * from "./editBooksType.vue?vue&type=script&lang=js&"
import style0 from "./editBooksType.vue?vue&type=style&index=0&id=5c9f344e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f344e",
  null
  
)

export default component.exports